import React from "react";
import Paper from "@mui/material/Paper";

import ToggleButtonGroup from "components/ToggleButtonGroup";

type Props = {
  floors: { label: string; value: number }[];
  currentFloor: number;
  setFloor: Function;
  disabled: boolean;
};

function FloorsButton({
  floors,
  currentFloor,
  setFloor,
  disabled,
}: Props): JSX.Element {
  if (!Array.isArray(floors) || !floors.length) return <></>;

  function handleChange(
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    value: number
  ) {
    if (value === null) return;
    return setFloor(value);
  }

  return (
    <Paper>
      <ToggleButtonGroup
        exclusive
        orientation="vertical"
        options={floors}
        value={currentFloor}
        onChange={handleChange}
        disabled={disabled}
      />
    </Paper>
  );
}

FloorsButton.defaultProps = {
  disabled: false,
};

export default FloorsButton;
